import { render, staticRenderFns } from "./jy-outbound.vue?vue&type=template&id=3fd16169&scoped=true&"
import script from "./jy-outbound.vue?vue&type=script&lang=js&"
export * from "./jy-outbound.vue?vue&type=script&lang=js&"
import style0 from "./jy-outbound.vue?vue&type=style&index=0&id=3fd16169&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fd16169",
  null
  
)

export default component.exports